module.exports = __webpack_public_path__ + "static/media/login_bg_9_1920x1080.08658dc7.jpg";